export default "__VITE_ASSET__CXusRrLs__"